import { createSelector } from 'reselect';
import { reduxKey } from '../constants';
function getStoreSlice(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey]['extensionGif'];
}
export const gifItems = createSelector(getStoreSlice, (state)=>{
    return state.items;
});
export const gifPage = createSelector(getStoreSlice, (state)=>{
    return state.page;
});
export const gifFetching = createSelector(getStoreSlice, (state)=>{
    return state.fetching;
});
export const gifHasMore = createSelector(getStoreSlice, (state)=>{
    return state.hasMore;
});
export const gifApiError = createSelector(getStoreSlice, (state)=>{
    return state.apiError;
});

//# sourceMappingURL=extension-gif.js.map